import { ErrorMessageDictionary } from "@thecb/components";
import { required, isProbablyEmail, matchesRegex } from "redux-freeform";

const getErrorDictionary = (fieldName: string): ErrorMessageDictionary => ({
  [required.error]: `${fieldName} is required`,
  [isProbablyEmail.error]: `Email is not valid`,
  [matchesRegex.error]: `${fieldName} must be decimal or integer`,
});

export default getErrorDictionary;
